import { runtimeEnvironment } from '../config/runtime-environment'

/**
 * Resolve the customer web app's password-recovery entrypoint.
 *
 * Admin owns sign-in, but password recovery still lives in the customer web
 * bundle. On a deployment host its origin comes from the page's own host
 * (ADR-0084); on a development host, from VITE_WEB_BASE_URL. An invalid
 * origin must never become an executable link; hiding recovery is safer than
 * sending an operator to the wrong origin.
 */
export function resolveWebRecoveryUrl(
  rawBase: string | null | undefined = runtimeEnvironment().webBaseUrl,
): string | null {
  const trimmed = rawBase?.trim()
  if (!trimmed) {
    return import.meta.env.DEV
      ? 'http://localhost:5183/forgot-password'
      : null
  }

  try {
    const base = new URL(trimmed)
    if (base.protocol !== 'http:' && base.protocol !== 'https:') return null
    return new URL('/forgot-password', base).href
  } catch {
    return null
  }
}
